import type { Grupo } from './api.js';

/**
 * Qué encabezado ve quien responde en cada tramo del cuestionario.
 *
 * Se prefiere la frase que escribió la psicóloga y se cae al nombre clínico
 * cuando todavía no la hay. Las quince frases se escriben de a una desde el
 * panel, y hasta que estén todas el cuestionario tiene que seguir teniendo
 * encabezados: un tramo sin título no es una opción.
 *
 * ES UNA FUNCIÓN Y NO UN `??` SUELTO EN LA PANTALLA porque esta es la regla que
 * decide qué nombre lee la persona de sí misma. Aquí se puede probar; dentro
 * del JSX no.
 */
export function tituloDeGrupo(grupo: Pick<Grupo, 'titulo' | 'tituloParaLaPersona'>): string {
  const frase = grupo.tituloParaLaPersona?.trim() ?? '';
  return frase === '' ? grupo.titulo : frase;
}
